<template>
  <div class="tg-document">
    <div class="tg-document--title" :class="titleClass">
      <i class="tg-icon tg-icon-info"></i>
      <span>{{title}}</span>
    </div>
    <div class="tg-document--content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    titleClass: [String, Object, Array],
  },
};
</script>